import { isValid, parseISO } from 'date-fns'

const ETA_DATE_FORMAT = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'UTC',
  day: '2-digit',
  month: 'short',
  year: 'numeric',
})
const ETA_TIME_FORMAT = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'UTC',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
})

// Rendered in UTC (not the viewer's local time) so the same value reads the
// same for every user, regardless of where they are.
export function formatMaintenanceEta(value: unknown): string {
  if (typeof value !== 'string' || !value) {
    return ''
  }

  const parsed = parseISO(value)
  if (!isValid(parsed)) {
    return value
  }

  return `${ETA_DATE_FORMAT.format(parsed)}, ${ETA_TIME_FORMAT.format(parsed)} UTC`
}
